import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Styles';
const LogoComponent = props => {
  return (
    props.logo && (
      <NavLink
        className={props.startComponentRender ? styles.startLogo : styles.logo}
        to={props.baseUrl}
        onClick={props.logoRedirect}
      >
        <img src={props.logo + '?h=120&logoTime=' + props.logoTime} alt="Logo" />
      </NavLink>
    )
  );
};

export default LogoComponent;
